import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Moment from "moment";

const emptyCell = (value) => {
  if (value == null) return "";
  if (value === "") return "";
  if (typeof value === "string" && (value === "null" || value === "undefined" || value.trim() === "")) return "";
  return value;
};

const pdfSafeCurrency = (value) => {
  if (typeof value !== "string") return value;
  return value.replace(/₨\s*/g, "Rs. ").replace(/₹\s*/g, "₹. ").replace(/¨\s*/g, "Rs. ");
};

const normalizeRow = (row) =>
  (Array.isArray(row) ? row.map(emptyCell) : [emptyCell(row)]).map((cell) =>
    typeof cell === "string" ? pdfSafeCurrency(cell) : cell
  );

class FileHelper {
  generatePdf = (logo, pdfData, title, callback) => {
    const pdfsize = "a1";
    const doc = new jsPDF("l", "in", pdfsize);
    const date = Moment(new Date(), "DD-MM-YYYY").format("LL");
    doc.text(`Generated at: ${date}`, 29.6, 1);
    if (logo) {
      doc.addImage(logo, "JPEG", 0.5, 0.3, 2, 1);
    }

    const headRow = pdfData.shift();
    const normalizedHead = normalizeRow(headRow);
    const columnCount = normalizedHead.length;
    const head = [normalizedHead];

    const body = pdfData.map((row) => {
      const normalized = normalizeRow(row);
      while (normalized.length < columnCount) normalized.push("");
      return normalized.slice(0, columnCount);
    });

    const pageWidth = doc.internal.pageSize.getWidth ? doc.internal.pageSize.getWidth() : doc.internal.pageSize.width;
    const margin = 0.3;
    const tableWidth = pageWidth - margin * 2;

    autoTable(doc, {
      head,
      body,
      startY: 1.5,
      margin: { left: margin, right: margin },
      tableWidth,
      styles: {
        minCellHeight: 0.8,
        cellPadding: 0.08,
      },
    });

    doc.save(`${title} - ${date}.pdf`);
    if (!callback) {
      setTimeout(() => {
        window.close();
      }, 500);
    } else {
      callback();
    }
  };

  loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      if (!url) {
        reject();
      }
      img.onload = () => resolve(img);
      img.src = url;
    });
  }
}

export default new FileHelper();
